import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Button,
  Stack,
  Paper,
} from "@mui/material";
import { Add, Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { layoutCSS } from "../component/common/commonStyle";
import { useGetAllBotsListQuery } from "../store/services/rcstemplateApi";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";

const BotsList = () => {
  const navigate = useNavigate();
  const [customerId, setCustomerId] = useState(null);

  useEffect(() => {
    try {
      const token = localStorage.getItem("accessToken");

      if (!token) {
        toast.error("Access token not found in local storage");
        return;
      }

      const decoded = jwtDecode(token);
      const id = decoded?.customer_id || decoded?.id || decoded?.userid || null;

      if (!id) {
        toast.error("Customer ID not found in decoded token");
      } else {
        setCustomerId(id);
      }
    } catch (err) {
      console.error("Error decoding token:", err);
      toast.error("Invalid access token format");
    }
  }, []);

  // Fetch Bots List
  const { data: botsData } = useGetAllBotsListQuery(customerId);
  console.log("botsData:", botsData);

  // Map API response
  const bots =
    botsData?.data?.map((item, index) => ({
      id: item.rcs_customer_bot_id,
      srNo: index + 1,
      botName: item.agent_name,
      botType: item.bot_type_name,
      status: item.status,
    })) || [];

  const handleAddNewBot = () => {
    navigate("/rcs-bot");
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "LAUNCHED":
        return "success";
      case "SUSPENDED":
        return "error";
      case "PENDING":
        return "warning";
      default:
        return "default";
    }
  };
  const tableCellBorder = {
    borderBottom: "0.5px solid #1b1b1bff",
    borderRight: "0.5px solid #1b1b1bff",
  };

  return (
    <Box sx={layoutCSS}>
      <Container maxWidth="xl" sx={{ py: 2 }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        ></Box>

        {/* Count */}
        <Paper
          sx={{
            p: 1.5,
            mb: 2,
            backgroundColor: "primary.light",
            color: "white",
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold">
            Total Bots: {bots.length}
          </Typography>
        </Paper>

        {/* Table */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small">
            <TableHead sx={{ backgroundColor: "#488df5" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", color: "white", ...tableCellBorder }}>Sr No</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white", ...tableCellBorder }}>Bot Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white", ...tableCellBorder }}>Bot Type</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "white", ...tableCellBorder }}>Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {bots.map((bot) => (
                <TableRow key={bot.id}>
                  <TableCell sx={tableCellBorder}>{bot.srNo}</TableCell>
                  <TableCell sx={tableCellBorder}>{bot.botName}</TableCell>
                  <TableCell sx={tableCellBorder}>{bot.botType}</TableCell>

                  <TableCell sx={tableCellBorder}>
                    <Chip
                      label={bot.status}
                      color={getStatusColor(bot.status)}
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Footer Count */}
        <Box sx={{ mt: 1, textAlign: "right" }}>
          <Typography variant="body2" fontWeight="bold">
            Total Bots: {bots.length}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default BotsList;
